"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevioEvents = void 0;
var types_1 = require("./types");
exports.ElevioEvents = {
    /**
     * Triggered whenever an article has been viewed, either in a custom element or in the Assistant.
     *
     * NOTE: this is not used when a knowledge base page is viewed, instead see { pageViewArticle }
     * */
    articleView: function (context) { return types_1.createEvent("article_view", context); },
    /**
     * Triggered when the Assistant launcher button is clicked.
     */
    launcherClicked: function () { return types_1.createEvent("launcher_click"); },
    /**
     * Triggered when the the home page is viewed in the knowledge base.
     */
    pageViewIndex: function () { return types_1.createEvent("page_view_index"); },
    /**
     * Triggered when an article page is viewed in the knowledge base.
     */
    pageViewArticle: function (context) { return types_1.createEvent("page_view_article", context); },
    /**
     * Triggered when a category page is viewed in the knowledge base.
     */
    pageViewCategory: function (context) { return types_1.createEvent("page_view_category", context); },
    /**
     * Triggered when a search has been completed.
     *
     * @param
     */
    searchQuery: function (_a) {
        var event_ctx_queryTerm = _a.event_ctx_queryTerm, event_ctx_totalResults = _a.event_ctx_totalResults, event_ctx_articleIds = _a.event_ctx_articleIds;
        var filteredTerm = event_ctx_queryTerm.substring(0, 255);
        return types_1.createEvent("search_query", {
            event_ctx_queryTerm: filteredTerm,
            event_ctx_totalResults: event_ctx_totalResults,
            event_ctx_articleIds: event_ctx_articleIds,
        });
    },
    /**
     * Triggered when a user clicks on a search result.
     */
    searchClick: function (context) { return types_1.createEvent("search_click", context); },
    walkthroughComplete: function (context) {
        return types_1.createEvent("walkthrough_complete", context);
    },
    walkthroughSkip: function (context) {
        return types_1.createEvent("walkthrough_skip", context);
    },
    walkthroughStepView: function (context) { return types_1.createEvent("walkthrough_step_view", context); },
    widgetClose: function () { return types_1.createEvent("widget_close"); },
    widgetOpen: function () { return types_1.createEvent("widget_open"); },
    articleFeedbackReaction: function (context) { return types_1.createEvent("article_feedback_reaction", context); },
    /**
     * Triggered when a user submits feedback text for an article.
     * NOTE: you will need a valid nonce first.
     */
    articleFeedbackText: function (context) { return types_1.createEvent("article_feedback_text", context); },
};
